import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DateSlot } from 'src/app/model/dateslot.model';

@Component({
  selector: 'app-date-period-edit',
  templateUrl: './date-period-edit.component.html',
  styleUrls: ['./date-period-edit.component.css']
})
export class DatePeriodEditComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<DatePeriodEditComponent>, @Inject(MAT_DIALOG_DATA) public dateSlot: DateSlot) {}

  ngOnInit() {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (this.dateSlot.start > this.dateSlot.end) {
      const tempStart = this.dateSlot.start;
      this.dateSlot.start = this.dateSlot.end;
      this.dateSlot.end = tempStart;
    }
    this.dialogRef.close(this.dateSlot);
  }
}
